export default __webpack_public_path__ + "static/media/Path3456.fb63d0f2.svg";